import {IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonText} from '@ionic/react';
import AuctionsMgmtGrid from '../components/AuctionsMgmtGrid';
import './Admin.css';
import NavComponent from "../components/NavComponent";
import {AuthUser} from "aws-amplify/auth";
import {WithAuthenticatorProps} from "@aws-amplify/ui-react";


const AdminList = ({user, signOut}: WithAuthenticatorProps) => {
    return (
        <IonPage>
            <div className={"bg-white"}>
                <IonContent fullscreen>
                    <IonToolbar>
                        <IonTitle>
                            <div className={"bg-white"}>
                                <img src="assets/images/MADfreight-logo.png" alt="logo"/>
                            </div>
                        </IonTitle>
                        <NavComponent signOut={signOut}/>
                    </IonToolbar>
                    <IonItem>
                        <IonLabel className="ion-text-wrap">
                            <IonText color="primary">
                                <h2>Auctions Management</h2>
                            </IonText>
                        </IonLabel>
                    </IonItem>
                    <AuctionsMgmtGrid name="Manage Auctions" user={user ?? {} as AuthUser}/>
                </IonContent>
            </div>
        </IonPage>
    );
};

export default AdminList;
